import { gql } from 'apollo-boost';

export const dealRowFragment = gql`
    fragment DealRowFragment on GdiDeal {
        id
        name
        status
        completeReason
        dateStart
        dateEnd
        description
        expectedMoneyPerWeek
        expectedImpressionsPerWeek
        dealType
        contacts
        minPrice
        targetingsText
        agencyFeePercent
        currencyCode
        publisherName
        numberOfLinkedCampaigns
        clicks
        cpc
        cpm
        ctr
        placements {
            domain
            formats
        }
        shows
        spent
    }
`;

export const dealsQuery = gql`
    query DealsQuery(
        $login: String!
        $limit: Int = 10000
        $offset: Int = 0
        $selectedDealIds: [Long!]
        $needStats: Boolean!
        $orderBy: [GdDealOrderByInput!]
        $filter: GdiDealFilterInput = {}
        $cacheKey: String
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            deals(
                limitOffset: { limit: $limit, offset: $offset }
                orderBy: $orderBy
                needStats: $needStats
                filter: $filter
                selectedDealIds: $selectedDealIds
                cacheKey: $cacheKey
            ) {
                rowset {
                    ...DealRowFragment
                }
                totalCount
                cacheKey
                dealIds
            }
        }
    }
    ${dealRowFragment}
`;
